import PropTypes from 'prop-types';
import React, {Component} from 'react';
import _ from 'lodash';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import {getElementMethods} from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {elementTypes} from 'crazyEditor/components/Elements/index';
import * as Consts from './Consts.js';
import * as Colors from 'material-ui/styles/colors';
import ImageManager from './ImageManagerConnect';
import GlobalStore from './GlobalStore';

const INITIAL_STATE = {
  images: null,
};

export default class IconDialog extends Component {
  constructor(props) {
    super(props);

    this.onAddUpdate = this.onAddUpdate.bind(this);
    this.getElementProps = this.getElementProps.bind(this);

    this.state = INITIAL_STATE;
  }

  onAddUpdate = () => {
    const {onAddUpdate} = this.props;
    const {images} = this.state;
    let url = _.first(images).url;
    url = url.substr(0, url.lastIndexOf('.')) + '.svg';
    getElementMethods(elementTypes.IconElement).getRawSvg(url, rawSVG => {
      onAddUpdate(this.getElementProps(rawSVG));
    });
  };

  getElementProps(rawSVG) {
    return {
      data: {
        rawSVG: rawSVG,
      },
    };
  }

  render() {
    const {onCancel, open, newElement} = this.props;
    const {images} = this.state;
    return (
      <BaseElementDialog
        open={open}
        newElement={newElement}
        title={`${newElement ? 'Add' : 'Edit'} Icon`}
        onCancel={onCancel}
        inputValid={_.size(images) === 1}
        onAddUpdate={this.onAddUpdate}
        contentStyle={{
          width: Consts.DIALOG_WIDTH,
          maxWidth: Consts.DIALOG_WIDTH,
          height: Consts.DIALOG_HEIGHT,
          maxHeight: Consts.DIALOG_HEIGHT,
        }}
        innerDivStyle={{
          height: Consts.CONTENT_HEIGHT,
          maxHeight: Consts.CONTENT_HEIGHT,
        }}
        buttonsSectionStyle={{backgroundColor: Colors.grey50}}
      >
        <ImageManager
          selectedImages={images}
          changeImages={images => this.setState({images})}
          resourceType="Icons"
          style={{height: '100%', width: '100%'}}
        />
      </BaseElementDialog>
    );
  }
}
